import {
  FETCH_TRANSLATION_START,
  FETCH_TRANSLATION_SUCCESS,
  FETCH_TRANSLATION_FAILURE
} from '../actionTypes';
import * as api from '../api.js';
export const fetchTranslation = () => async dispatch => {
  dispatch({ type: FETCH_TRANSLATION_START });

  api
    .getTranslation()
    .then(data => {
      dispatch({
        type: FETCH_TRANSLATION_SUCCESS,
        payload: data
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_TRANSLATION_FAILURE,
        payload: err,
        error: true
      });
    });
};
